import { AxiosError } from "axios";
import { QueryKey, useQuery } from "react-query";
import PartnersShowcaseService from "#/api/partnersShowcase/partnersShowcase";
import { errorTransform } from "#/infrastructure/error-handler";
type PartnerType = "SISTEMICO" | "LOCAL";

type GetCategoryPartnerActiveParams = {
  options?: Record<string, unknown>;
  page?: number;
  typePartner?: PartnerType;
  size?: number;
  city?: string;
  uf?: string;
  partnerName?: string;
};
export const useGetCategoryPartnerActive = ({
  options = {},
  page = 0,
  typePartner = "SISTEMICO",
  size,
  city,
  uf,
  partnerName,
}: GetCategoryPartnerActiveParams) => {
  return useQuery(
    [
      "categoryPartnerActive",
      page,
      size,
      city,
      uf,
      typePartner,
      partnerName,
    ] as QueryKey,
    () =>
      PartnersShowcaseService.getCategoryPartnerActive({
        page,
        typePartner,
        size,
        city,
        uf,
        partnerName,
      }),
    {
      enabled: true,
      ...options,
      onError: (responseError: AxiosError) => {
        throw errorTransform(
          responseError,
          "Falha ao buscar categorias. Tente novamente."
        );
      },
    }
  );
};
